module.exports = __webpack_public_path__ + "img/Compliance Automation_old.e9b600f9.svg";